<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Code" label="编码" width="">
        </el-table-column>
        <el-table-column prop="Name" label="名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>
        <el-table-column label="应用到门禁" width="">
          <template slot-scope="scope">
            <el-tag type="success"
              v-if="scope.row.IsApplyToAccess === null || scope.row.IsApplyToAccess === undefined || scope.row.IsApplyToAccess">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Sort" label="顺序号" width="">
        </el-table-column>
      </el-table>
      </div>

      <!--编辑界面-->
      <el-dialog title="编辑请假类型" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
          <el-form-item label="编码" prop="Code">
            <el-input v-model="editForm.Code" auto-complete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="editForm.Sort"></el-input-number>
          </el-form-item>
          <el-form-item label="应用到门禁" prop="IsApplyToAccess">
            <el-switch v-model="editForm.IsApplyToAccess" @change="onApplySwitchChange('edit',$event)" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增请假类型" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item label="编码" prop="Code">
            <el-input v-model="addForm.Code" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="addForm.Sort"></el-input-number>
          </el-form-item>
          <el-form-item label="应用到门禁" prop="IsApplyToAccess">
            <el-switch v-model="addForm.IsApplyToAccess" @change="onApplySwitchChange('add',$event)" active-text="是" inactive-text="否"></el-switch>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getLeaveTypeListPage, editLeaveType, addLeaveType, removeLeaveType } from '../../api/modules/misc';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Code: [
          { required: true, message: "请输入编码", trigger: "blur" },
        ],
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        BeignTime: '',
        EndTime: '',
        Sort: 0,
        DepartmentId: 0,
        IsApplyToAccess: true,
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Code: [
          { required: true, message: "请输入编码", trigger: "blur" },
        ],
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        BeignTime: '',
        EndTime: '',
        Sort: 0,
        DepartmentId: 0,
        IsApplyToAccess: true
      },

      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
    };
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getLeaveTypeListPage(para).then((res) => {
        this.users = res.data.response;
        this.listLoading = false;
      });
    },
    formatBool(row, column, cellValue) {
      if (cellValue === null || cellValue === undefined) return '是';
      return cellValue ? '是' : '否';
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      // 后端旧数据可能为 null，按兼容规则视为已应用（等同于 true）
      if (this.editForm.IsApplyToAccess === null || this.editForm.IsApplyToAccess === undefined) {
        this.editForm.IsApplyToAccess = true;
      }
    },
    onApplySwitchChange(which, val) {
      // 强制布尔化并打印，便于调试切换无反应的问题
      const v = !!val;
      if (which === 'edit') {
        this.editForm.IsApplyToAccess = v;
      } else {
        this.addForm.IsApplyToAccess = v;
      }
      console.log('IsApplyToAccess change', which, v);
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editLeaveType(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeLeaveType(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        BeignTime: '',
        EndTime: '',
        Sort: 0,
        DepartmentId: this.DepartmentId,
        IsApplyToAccess: true
      };
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            addLeaveType(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
